import React, { useState, useEffect, useContext, useCallback } from "react";
import { Link, useLocation, useParams, useHistory } from "react-router-dom";
import Slider from "react-slick";
import { PageSettings } from "../../config/page-settings";
import ModalVideo from "react-modal-video";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  UncontrolledButtonDropdown,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import MagicSliderDots from "react-magic-slider-dots";
import "react-magic-slider-dots/dist/magic-dots.css";
import "react-multi-carousel/lib/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-modal-video/css/modal-video.css";
import ImageViewer from "react-simple-image-viewer";
import Config from "../../Config.js";
import { VideoTag } from "react-video-tag";
import DOMPurify from "dompurify";
import MobileStoreButton from "react-mobile-store-button";
import YouTube from "react-youtube";
import { RWebShare } from "react-web-share";
import QRCode from "qrcode.react";
import { NumericFormat } from "react-number-format";
import { Helmet } from "react-helmet";
import renderHTML from "react-render-html";
import Productdetailsfooter from "./productdetailsfooter";
//import LoadingSpinner from "../Loder/LoadingSpinner";
import axios from "axios";
import { postAbusereport, postsendemailchat } from "api/apiproductreport";
import swal from "sweetalert";

import {
  isAndroid,
  isIOS,
  browserName,
  osName,
  isMobile,
} from "react-device-detect";
import { message } from "antd";

const Detail = () => {
  console.log("deviceType==>", osName);
  console.log("isMobile==>", isMobile);
  const location = useLocation().search;
  const locationPath = window.location.href;
  const context = useContext(PageSettings);
  let history = useHistory();
  const mapId = new URLSearchParams(location).get("mapId");
  const rendername = new URLSearchParams(location).get("render");
  const ProductType = new URLSearchParams(location).get("maptarget");
  const StaticDetails = new URLSearchParams(location).get("Static");
  //const mapId = location.state.mapId;
  //const rendername =  location.state.render;
  // const [ProductID, setProductID] = useState(location.state.ProductID);
  // const [ProductID, setProductID] = useState("6219ea71c72583a1916b2dab");
  const [collapse, setcollapse] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [webhidePass, setwebHidePass] = useState(true);
  const [sharehidePass, setshareHidePass] = useState(true);
  const [wallethidePass, setwalletHidePass] = useState(true);
  const [qrhidePass, setqrhidePass] = useState(true);
  const [hearthidePass, setheartHidePass] = useState(true);
  const [modalCertificateimg, setmodalCertificateimg] = useState(false);
  const [ModalVideoPlayer, setModalVideoPlayer] = useState(false);
  const [CirtificateItem, setCirtificateItem] = useState("");
  const [VideoPlayerItem, setVideoPlayerItem] = useState("");
  const [modalqrcode, setmodalqrcode] = useState(false);
  const [modalsizetable, setmodalsizetable] = useState(false);
  const [modalMobileStore, setmodalMobileStore] = useState(false);
  const [modalReportabuse, setmodalReportabuse] = useState(false);
  const [show, setShow] = useState(false);

  const [articleSegmentList, setarticleSegmentList] = useState([]);
  const [articleSegmentWebLinkList, setarticleSegmentWebLinkList] = useState(
    []
  );
  const [SegmentDescription, setSegmentDescription] = useState("");
  const [SegmentDescriptionError, setSegmentDescriptionError] = useState("");
  //const [VideosegmentList, setVideosegmentList] = useState([]);
  const [ArticleSegmentDocumentlist, setArticleSegmentDocumentlist] = useState(
    []
  );
  const [ArticleSegmentImageLists, setArticleSegmentImageLists] = useState([]);
  const [ArticleSegmentID, setArticleSegmentID] = useState("");
  const [ArticleName, setArticleName] = useState("");
  const [variantList, setvariantList] = useState([]);
  const [articleImage, setarticleImage] = useState([]);
  const [articleImagetemp, setarticleImagetemp] = useState([]);
  const [articleCategoryName, setarticleCategoryName] = useState([]);
  const [articlesubCategoryName, setarticlesubCategoryName] = useState([]);
  const [articlePrice, setarticlePrice] = useState("0");
  const [articlelable, setarticlelable] = useState();
  const [articlelableImagePath, setarticlelableImagePath] = useState("");
  const [shortDescription, setshortDescription] = useState("");
  const [articleCertificates, setarticleCertificates] = useState([]);
  const [sizeTableImage, setsizeTableImage] = useState("");
  const [CombinationDetails, setCombinationDetails] = useState("");
  const [selectCombinationID, setselectCombinationID] = useState("");
  const [Combinationattributeprice, setCombinationattributeprice] = useState(0);

  const [selectCombinationdisabled, setselectCombinationdisabled] =
    useState(false);
  const [CombinationattributeValue1, setCombinationattributeValue1] =
    useState("");
  const [CombinationattributeValue2, setCombinationattributeValue2] =
    useState("");
  const [CombinationattributeValue3, setCombinationattributeValue3] =
    useState("");
  const [CombinationattributeValue4, setCombinationattributeValue4] =
    useState("");
  const [CombinationattributeValue5, setCombinationattributeValue5] =
    useState("");

  const [IsPublished, setIsPublished] = useState(false);
  // const [collapseslidermodal, setcollapseslidermodal] = useState(false)
  const [modalsliderImage, setmodalsliderImage] = useState([]);

  const [relatedproduct, setrelatedproduct] = useState([]);
  const [productLogoPath, setproductLogoPath] = useState("");
  const [isPublishedLogo, setisPublishedLogo] = useState(false);

  const [isArticleDescriptionDisplay, setisArticleDescriptionDisplay] =
    useState(false);
  const [isArticleDistanceDisplay, setisArticleDistanceDisplay] =
    useState(false);
  const [isArticleDocumentDisplay, setisArticleDocumentDisplay] =
    useState(false);
  const [isArticleImageDisplay, setisArticleImageDisplay] = useState(false);
  const [isArticleTypeDisplay, setisArticleTypeDisplay] = useState(false);
  const [isArticleVideoDisplay, setisArticleVideoDisplay] = useState(false);
  const [isArticleWebLinkDisplay, setisArticleWebLinkDisplay] = useState(false);
  const [isCertificateDisplay, setisCertificateDisplay] = useState(false);
  const [isLabelDisplay, setisLabelDisplay] = useState(false);
  const [isNameAndCatDisplay, setisNameAndCatDisplay] = useState(false);
  const [isClickToConnectNow, setClickToConnectNow] = useState(false);
  const [isPriceDisplay, setisPriceDisplay] = useState(false);
  const [isShortDescriptionDisplay, setisShortDescriptionDisplay] =
    useState(false);
  const [isSizeTabelDisplay, setisSizeTabelDisplay] = useState(false);
  const [isSKUDisplay, setisSKUDisplay] = useState(false);
  const [isEnableMadeIndisplay, setisEnableMadeIndisplay] = useState(false);
  const [isTravelDistanceEnable, setisTravelDistanceEnable] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [selectImage, setselectImage] = useState([]);
  const [subcurrentImage, setsubCurrentImage] = useState(0);
  const [subcurrentDocument, setsubCurrentDocument] = useState(0);
  const [subisViewerOpen, setsubIsViewerOpen] = useState(false);
  const [docisViewerOpen, setdocIsViewerOpen] = useState(false);
  const [subselectDocument, setsubselectDocument] = useState([]);
  const [subselectImage, setsubselectImage] = useState([]);
  const [QrCodeString, setQrCodeString] = useState(null);

  const [productinfo, setproductinfo] = useState(null);
  const [isLoading, setisLoading] = useState(false);

  const [Qrodedetails, setQrodedetails] = useState(null);
  const [isfirstloding, setisfirstloding] = useState(false);

  const [BrandingLogoPath, setBrandingLogoPath] = useState("");
  const [WhiteLabellingName, setWhiteLabellingName] = useState("");

  const [SelectTypeofabuse, setSelectTypeofabuse] = useState("Nudity");
  const [latitude, setlatitude] = useState("");
  const [longitude, setlongitude] = useState("");

  const [OtherYouTubeLink, setOtherYouTubeLink] = useState("");
  const [isPublishedBarding, setisPublishedBarding] = useState(false);
  const [isPublishedTagLine, setisPublishedTagLine] = useState(false);

  const [modalemailchat, setmodalemailchat] = useState(false);

  const [userchatemail, setuserchatemail] = useState("");
  const [userchatmessage, setuserchatmessage] = useState("");
  const [userchatname, setuserchatname] = useState("");
  const [ischatsendme, setischatsendme] = useState(false);

  const [articleProductTheme, setArticleProductTheme] = useState(null);

  const [CompanyEmailError, setCompanyEmailError] = useState("");

  useEffect(() => {
    context.handleSetPageSidebar(false);
    context.handleSetPageHeader(false);
    context.handleSetPageContentFullWidth(true);
    context.handleSetpagecontainer(false);
    // return a function to execute at unmount
    return () => {
      context.handleSetPageSidebar(true);
      context.handleSetPageHeader(true);
      context.handleSetpagecontainer(true);
      context.handleSetPageContentFullWidth(false);
    };
  }, []); // notice the empty array

  useEffect(() => {
    getBrandingLogoandWhiteLabelling(ProductType, rendername, mapId);
  }, [mapId]);

  const getBrandingLogoandWhiteLabelling = async (
    productType,
    renderName,
    MapId
  ) => {
    if (
      productType !== null &&
      productType !== "" &&
      productType !== undefined &&
      MapId !== "" &&
      MapId !== null &&
      MapId !== undefined &&
      renderName !== "" &&
      renderName !== undefined &&
      renderName !== null
    ) {
      // setTimeout(() => {
      //   setisfirstloding(true);
      // }, 300);
      setisfirstloding(true);

      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/GetBrandingLogoandWhiteLabelling?id=" +
        MapId +
        "&rendername=" +
        renderName +
        "&ProductType=" +
        productType +
        "&Latitude=",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then(async (responseJson) => {
          setisPublishedBarding(
            responseJson?.isPublishedBarding
              ? responseJson?.isPublishedBarding
              : false
          );
          setisPublishedTagLine(
            responseJson?.isPublishedTagLine
              ? responseJson?.isPublishedTagLine
              : false
          );
          if (
            responseJson?.brandingLogo !== null &&
            responseJson?.brandingLogo !== "" &&
            responseJson?.brandingLogo !== undefined
          ) {
            setBrandingLogoPath(Config.contentUrl + responseJson?.brandingLogo);
          } else {
            setBrandingLogoPath("");
          }
          setWhiteLabellingName(responseJson?.labellingName);
          // setTimeout(() => {
          //   setisfirstloding(false);
          // }, 300);
          setisfirstloding(false);
          await updateTotalScans(productType, renderName, MapId);
        })
        .catch((error) => {
          console.log(error);
          setisfirstloding(false);
          setisLoading(false);
          // setTimeout(() => {
          //   setisfirstloding(false);
          // }, 300);
        });
    }
    // setisLoading(false);
  };

  const openImageViewer = (item, i) => {
    setCurrentImage(i);
    let test = [];
    let Testmdata = [...articleImage];
    for (let index = 0; index < Testmdata.length; index++) {
      if (rendername === "Combination") {
        if (isArticleTypeDisplay === true) {
          const element = Testmdata[index];
          if (element !== null && element !== undefined && element !== "") {
            test.push(Config.contentUrl + element);
          }
        }
      } else {
        const element = Testmdata[index].filePath;
        if (element !== null && element !== undefined && element !== "") {
          test.push(Config.contentUrl + element);
        }
      }
    }
    if (test.length > 0) {
      setselectImage(test);
      setIsViewerOpen(true);
    }
  };
  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };
  const subopenImageViewer = (item, i) => {
    setsubCurrentImage(i);
    let test = [];
    let Testmdata = item;
    for (
      let index = 0;
      index < Testmdata.articleSegmentImageList.length;
      index++
    ) {
      const element = Testmdata.articleSegmentImageList[index].filePath;
      test.push(Config.contentUrl + element);
    }

    setsubselectImage(test);
    setsubIsViewerOpen(true);
  };
  const subcloseImageViewer = () => {
    setsubCurrentImage(0);
    setsubIsViewerOpen(false);
  };
  const subopenDocumentViewer = (item, i) => {
    setsubCurrentDocument(i);
    let test = [];
    let Testmdata = item;
    for (let index = 0; index < Testmdata.length; index++) {
      if (Testmdata[index]?.fileExtension !== ".pdf") {
        const element = Testmdata[index].filePath;
        console.log("imageUrl=>1", element);
        test.push(Config.contentUrl + element);
      }
    }

    // setsubselectImage(test);
    setsubselectDocument(test);
    setdocIsViewerOpen(true);
  };
  const subcloseDocumentViewer = () => {
    setsubCurrentDocument(0);
    setdocIsViewerOpen(false);
  };
  // useEffect(() => {
  //   updateTotalScans(ProductType, rendername, mapId);
  // }, [mapId]);

  const updateTotalScans = async (productType, renderName, MapId) => {
    if (
      productType !== null &&
      productType !== "" &&
      productType !== undefined &&
      MapId !== "" &&
      MapId !== null &&
      MapId !== undefined &&
      renderName !== "" &&
      renderName !== undefined &&
      renderName !== null
    ) {
      const res = await axios.get("https://geolocation-db.com/json/");
      console.log("geolocation==>", res);
      if (res !== null) {
        setlatitude(res?.data?.latitude);
        setlongitude(res?.data?.longitude);
        fetch(
          Config.apiUrl +
          "QRCodeScanHistory/updateTotalScans?id=" +
          MapId +
          "&rendername=" +
          renderName +
          "&ProductType=" +
          productType +
          "&Latitude=" +
          res?.data?.latitude +
          "&Longitude=" +
          res?.data?.longitude,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }

            throw new Error("Something went wrong");
          })
          .then((responseJson) => {
            if (responseJson === true) {
              if (ProductType === "article") {
                if (rendername === "details") {
                  GetAllProductInfo(mapId);
                } else if (rendername === "Combination") {
                  GetAllCombinationInfo(mapId);
                }
              } else if (ProductType === "product") {
                getQrCodeResourceinfo(mapId);
              } else if (ProductType === "personal") {
                setisLoading(false);
                if (StaticDetails === "false") {
                } else {
                }
              }
            } else {
              setisLoading(false);
              swal("Please contact the administrator");
            }
          })
          .catch((error) => {
            setisLoading(false);
            console.log(error);
          });
      }
    }
    // setisLoading(false);
  };

  const GetAllQrCodeInformation = (targetId) => {
    if (
      targetId !== null &&
      targetId !== "" &&
      targetId !== undefined &&
      targetId !== "undefined"
    ) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/WebByIdWithOutUserID?id=" +
        targetId,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          setQrodedetails(result);
          // console.log("WrCodeInformation==>",result)
        });
      });
    } else {
      setQrodedetails(null);
    }
  };

  const CreateQrCodeScanhistory = () => {
    alert(window.navigator.userAgent);

    console.log("userinfo", window.navigator.platform);
    // try {
    //     let LatitudeObj = "";
    // let LongitudeObj = "";
    // navigator.geolocation.getCurrentPosition(function (position) {
    //     console.log("Latitude is :", position.coords.latitude);
    //     console.log("Longitude is :", position.coords.longitude);
    //     LatitudeObj = position.coords.latitude;
    //     LongitudeObj = position.coords.longitude;

    // });

    // let ScanhistoryModel = {
    //     "UserCompanyID": "",
    //     "QrCodeID": "",
    //     "Latitude": LatitudeObj,
    //     "Longitude": LongitudeObj,
    //     "City": "City123",
    //     "County": "county123",
    //     "Country": "country13",
    //     'Postcode': "PostCode123",
    //     'DeviceOS': "",
    //     'IsSavedToSTT': false,
    //     'scanDate': new Date(),
    //     'TargetID': mapId,
    //     'TargetType': ProductType,
    //     'IsDeleted': false,
    //     'CreatedDate': new Date(),
    //     'UpdatedDate': new Date(),
    //     'IsMyWishList': false,
    //     'HistoryName': "URL",
    //     'URL': locationPath,
    // }
    // fetch(Config.apiUrl + "QRCodeScanHistory/CreateQrCodeScanHistorywithoutuserid",
    //     {
    //         method: "POST",
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //         body: JSON.stringify(ScanhistoryModel)
    //     }).then((result1) => {
    //         result1.json().then((resp) => {
    //             console.log("Create qrcodehistory", resp)

    //         })
    //     })
    //     .catch((error) => {
    //         console.error('There was an error!', error);
    //     })
    // } catch (error) {
    //     alert("geolocation Error=>" + error)
    // }
  };

  // useEffect(() => {
  //     console.log("isLoading", isLoading)
  // }, [isLoading]);

  useEffect(() => {
    GetAllProductInfo(CombinationDetails?.articleID);
  }, [CombinationDetails]);

  const getProductQrcodeTheme = (articleidObj) => {
    fetch(
      Config.apiUrl +
      "productQrcodeTheme/GetProductQrcodeThemeByArticleProductId?ArticleProductId=" +
      articleidObj,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        if (resp1 !== null) {
          setArticleProductTheme(resp1);
        } else {
          setArticleProductTheme(null);
        }
      });
  };

  const GetAllProductInfo = (articleidObj) => {
    setisLoading(true);
    if (
      articleidObj != null &&
      articleidObj != "" &&
      articleidObj != undefined
    ) {
      setisLoading(true);
      //let loginid = localStorage.getItem("loginUserID");
      getProductQrcodeTheme(articleidObj);
      fetch(
        Config.apiUrl +
        "ArticleProduct/GetArticleAllInformationWithOutUserCompanyId?id=" +
        articleidObj,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            //"userCompanyID": loginid,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result._id != null) {
            setproductinfo(result);

            if (rendername !== "Combination" && ProductType != "product") {
              setIsPublished(result.isPublished);
            }
            setArticleName(result.articleName);
            if (result.categorydetail != null && result.categorydetail != "") {
              setarticleCategoryName(result.categorydetail.name);
              if (
                result.subCategoryDetail != null &&
                result.subCategoryDetail != ""
              ) {
                setarticlesubCategoryName(result.subCategoryDetail.name);
              }
            }
            if (
              result.articleAttribute != null &&
              result.articleAttribute != ""
            ) {
              // if (rendername === "Combination" && CombinationDetails != null && CombinationDetails != '') {
              //     result.articleAttribute.map((variantItem, i) => {
              //         if (variantItem.articleAttributeValue.length > 0) {
              //             variantItem.articleAttributeValue.map((variantsubItem) => {
              //                 if (i === 0) {
              //                     if (variantsubItem.value === CombinationDetails.attributeValue1) {
              //                         variantsubItem.isDeleted = true;
              //                     }

              //                 }
              //                 else if (i === 1) {
              //                     if (variantsubItem.value === CombinationDetails.attributeValue2) {
              //                         variantsubItem.isDeleted = true;
              //                     }
              //                 }
              //                 else if (i === 2) {
              //                     if (variantsubItem.value === CombinationDetails.attributeValue3) {
              //                         variantsubItem.isDeleted = true;
              //                     }
              //                 }
              //                 else if (i === 3) {
              //                     if (variantsubItem === CombinationDetails.attributeValue4) {
              //                         variantsubItem.isDeleted = true;
              //                     }
              //                 }
              //                 else if (i === 4) {
              //                     if (variantsubItem.value === CombinationDetails.attributeValue5) {
              //                         variantsubItem.isDeleted = true;
              //                     }
              //                 }
              //                 // return <option val={variantsubItem._id}>{variantsubItem.value}</option>
              //             })
              //         }

              //     })
              // }
              setvariantList(result?.articleAttribute);
            }
            if (result?.regularPrice != null && result?.regularPrice != "") {
              setarticlePrice(result?.regularPrice);
            } else {
              setarticlePrice("0");
            }
            if (result?.labelDetail != null && result?.labelDetail != "") {
              setarticlelable(result?.labelDetail.name);
              setarticlelableImagePath(
                Config.contentUrl + result?.labelDetail?.logoPath
              );
            }
            if (rendername === "details") {
              if (
                result?.articleImage.length > 0 &&
                result?.articleImage != null
              ) {
                setarticleImage(result?.articleImage);
                setarticleImagetemp(result?.articleImage);
              }
            }
            if (result?.sizeTabel != null && result?.sizeTabel != "") {
              setsizeTableImage(result?.sizeTabel);
            }
            setshortDescription(result?.shortDescription);
            if (
              result?.aarticleProductSegment != null &&
              result?.aarticleProductSegment != ""
            ) {
              setarticleSegmentList(result?.aarticleProductSegment);
            }
            setarticleCertificates(result?.certificateDetail);
          } else {
            setarticleSegmentList([]);
            // setisLoading(false);
          }

          if (result?.relatedproduct !== null) {
            setrelatedproduct(
              result?.relatedproduct.filter(
                (x) => x.relatedproductID !== articleidObj
              )
            );
          } else {
            setrelatedproduct([]);
          }
          setproductLogoPath(result?.productLogoPath);
          setisPublishedLogo(result?.userDetail.isPublishedLogo);
          setisArticleDescriptionDisplay(result?.isArticleDescriptionDisplay);
          setisArticleDistanceDisplay(result?.isArticleDistanceDisplay);
          setisArticleDocumentDisplay(result?.isArticleDocumentDisplay);
          setisArticleImageDisplay(result?.isArticleImageDisplay);
          setisArticleTypeDisplay(result?.isArticleTypeDisplay);
          setisArticleVideoDisplay(result?.isArticleVideoDisplay);
          setisArticleWebLinkDisplay(result?.isArticleWebLinkDisplay);
          setisCertificateDisplay(result?.isCertificateDisplay);
          setisEnableMadeIndisplay(result?.isEnableMadeIndisplay);
          setisLabelDisplay(result?.isLabelDisplay);
          setisNameAndCatDisplay(result?.isNameAndCatDisplay);
          setisPriceDisplay(result?.isPriceDisplay);
          setisShortDescriptionDisplay(result?.isShortDescriptionDisplay);
          setisSizeTabelDisplay(result?.isSizeTabelDisplay);
          setisSKUDisplay(result?.isSKUDisplay);
          setisTravelDistanceEnable(result?.isTravelDistanceEnable);
          setisSKUDisplay(result?.isSKUDisplay);
          setClickToConnectNow(result?.isArticleChatDisplay);
          // setisLoading(false);
          setTimeout(() => {
            setisLoading(false);
          }, 3000);
        });
      });
    }
  };

  const GetAllCombinationInfo = (CombinationID) => {
    //CombinationID = '625555e60e4be6235aa48fce'
    setisLoading(true);
    if (
      CombinationID != null &&
      CombinationID != undefined &&
      CombinationID != ""
    ) {
      fetch(
        Config.apiUrl +
        "AttributeValueMap/ByIdwithoutUserid?id=" +
        CombinationID,
        {
          headers: {
            "Content-Type": "application/json",
          },
          method: "GET",
        }
      )
        .then((result) => {
          result.json().then((resp) => {
            if (resp != null) {
              if (
                resp?.articleID != null &&
                resp?.articleID != "" &&
                resp?.articleID != undefined
              ) {
                if (
                  resp?.price !== null &&
                  resp?.price !== "" &&
                  resp?.price !== undefined
                ) {
                  let price = resp?.price?.trim();
                  let price1 = price.replace(",", "");
                  setCombinationattributeprice(price1);
                  // setCombinationattributeprice(parseFloat(resp?.price));
                } else {
                  setCombinationattributeprice(0);
                }
                setCombinationDetails(resp);
                if (ProductType !== "product") {
                  setIsPublished(resp?.isPublished);
                }

                setselectCombinationID(CombinationID);
                setselectCombinationdisabled(true);
                if (
                  resp?.attributeImagePath != null &&
                  resp?.attributeImagePath != ""
                ) {
                  let test = [];
                  test.push(resp?.attributeImagePath);
                  setarticleImage(test);
                  setarticleImagetemp(test);
                }
                setCombinationattributeValue1(resp?.attributeValue1);
                setCombinationattributeValue2(resp?.attributeValue2);
                setCombinationattributeValue3(resp?.attributeValue3);
                setCombinationattributeValue4(resp?.attributeValue4);
                setCombinationattributeValue5(resp?.attributeValue5);
                // GetAllProductInfo(resp.articleID);
              }
            }
          });
        })
        .catch((error) => {
          console.log(error);
          setisLoading(false);
        });
      // setisLoading(false);
    }
  };
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    appendDots: (dots) => {
      return <MagicSliderDots dots={dots} numDotsToShow={3} dotWidth={30} />;
    },
  };
  const settings2 = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2.3,
    slidesToScroll: 1,
    arrows: false,
  };
  const downloadImage = (Url, filename) => {
    window.open(Config.contentUrl + Url, "_blank");
    // Url = Config.contentUrl + Url;
    //saveAs(Url, filename) // Put your image url here.
  };
  // const downloadQrCodeImage = (Url) => {
  //     console.log("downloadQrCodeImage===>", Url)

  //     window.open(Url, "_blank")
  //     // Url = Config.contentUrl + Url;
  //     //saveAs(Url, filename) // Put your image url here.
  // }
  const downloadQrCodeImage = () => {
    const qrCodeURL = document
      .getElementById("DetailsE1")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log(qrCodeURL);
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };
  const downloadCirtificatepdgf = (Url, filename) => {
    if (Url?.length > 0) {
      window.open(Config.contentUrl + Url, "_blank");
    }
    // Url = Config.contentUrl + Url;
    // saveAs(Url, filename) // Put your image url here.
  };
  const toggleCertificateimg = (item) => {
    setmodalCertificateimg(!modalCertificateimg);
    setCirtificateItem(item);
  };
  const toggleVideoPlayer = (item) => {
    setModalVideoPlayer(!ModalVideoPlayer);
    setVideoPlayerItem(item);
  };
  const toggleqrcode = (item) => {
    setmodalqrcode(!modalqrcode);
    setQrCodeString(item);
  };
  const togglesizetable = () => {
    setmodalsizetable(!modalsizetable);
  };
  const toggleMobileStore = () => {
    setmodalMobileStore(!modalMobileStore);
  };
  const toggleemailChat = () => {
    setmodalemailchat(!modalemailchat);
  };

  const onclickwallet = () => {
    // setwalletHidePass(!wallethidePass);
    toggleMobileStore();
  };
  const onclickShare = () => {
    // <div>
    <RWebShare
      data={{
        text: "Like humans, flamingos make friends for life",
        url: "https://on.natgeo.com/2zHaNup",
        title: "Flamingos",
      }}
      onClick={() => console.log("shared successfully!")}
    />;
    {
      /* <button>Share 🔗</button>
            </RWebShare> */
    }
    {
      /* </div> */
    }
  };
  const onclickwishlist = () => {
    // setheartHidePass(!hearthidePass);
    toggleMobileStore();
  };
  const OpenExternallink = (url) => {
    if (!url.match(/^https?:\/\//i)) {
      url = "http://" + url;
    }
    window.open(url, "_blank");
    //window.open(url, "blank");
    //window.open(url, "_blank", "").focus();
    // window.location.href = url;
    // Object.assign(document.createElement('a'), {
    //     target: '_blank',
    //     href: url,
    //   }).click();
  };
  const OpenCertificateExternallink = (url) => {
    if (!url.match(/^https?:\/\//i)) {
      url = "http://" + url;
    }
    window.open(url, "_blank");
    //window.open(url, "blank");
    //window.open(url, "_blank", "").focus();
    // window.location.href = url;
    // Object.assign(document.createElement('a'), {
    //     target: '_blank',
    //     href: url,
    //   }).click();
  };

  const GotoHome = () => {
    history.push({
      pathname: "/home",
    });
  };

  // function getId(url) {
  //   var regExp =
  //     /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  //   var match = url.match(regExp);

  //   if (match && match[2].length == 11) {
  //     return match[2];
  //   } else {
  //     return "error";
  //   }
  // }
  // const convertHtml = (htmlInput) => {
  //   if (htmlInput != null && htmlInput != "" && htmlInput != undefined) {
  //     const mySafeHTML = DOMPurify.sanitize(htmlInput);

  //     const oembedRegex = /<oembed[^>]*>/g;
  //     const oembedMatch = htmlInput.match(oembedRegex);
  //     let finalurl = "";
  //     if (oembedMatch) {
  //       for (let index = 0; index < oembedMatch.length; index++) {
  //         const oembedUrl = oembedMatch[index].match(/url="([^"]*)"/)[1];
  //         if (
  //           oembedUrl !== null &&
  //           oembedUrl !== undefined &&
  //           oembedUrl !== null
  //         ) {
  //           finalurl = "https://www.youtube.com/embed/" + getId(oembedUrl);
  //         }
  //         const iframeElement = `<iframe width="420" height="345" src=${finalurl} controls=0"></iframe>`;

  //         htmlInput = htmlInput.replace(oembedRegex, iframeElement);
  //       }
  //     }

  //     console.log("Rajani==>", htmlInput);
  //     return (
  //       <div
  //         className="no-controls video-container"
  //         id="player"
  //         dangerouslySetInnerHTML={{ __html: mySafeHTML }}
  //         //className="editor"
  //       />
  //     );
  //   }
  // };
  const iOSUrl =
    "https://itunes.apple.com/us/app/all-of-the-lights/id959389722?mt=8";
  const androidUrl = "https://play.google.com";

  const getQrCodeResourceinfo = (QrcodeResourceID) => {
    setisLoading(true);
    if (
      QrcodeResourceID != null &&
      QrcodeResourceID != "" &&
      QrcodeResourceID != undefined
    ) {
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/GetQrcodeQrCodeResourceWithOutUserCompanyId?id=" +
        QrcodeResourceID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result?._id != null) {
            setQrodedetails(result);
            if (ProductType === "product") {
              setIsPublished(result?.isPublished);
            }
            if (result?.targetType === "productqrcode") {
              GetAllProductInfo(result?.mainTargetID);
            } else {
              if (
                result?.targetID !== "" &&
                result?.targetID !== null &&
                result?.targetID !== undefined
              ) {
                GetAllCombinationInfo(result?.targetID);
              } else {
                GetAllProductInfo(result?.mainTargetID);
              }
            }
          }
        });
      });
    }
  };

  const selectvariant = (event) => {
    if (event.target.value !== "0" && selectvariant !== 0) {
      let variantvaluemapping = productinfo?.attributeValueMappingList.find(
        (x) => x._id === event.target.value
      );
      if (
        variantvaluemapping !== undefined &&
        variantvaluemapping !== null &&
        variantvaluemapping !== ""
      ) {
        let temp = [];
        let variant = {
          filePath: variantvaluemapping?.attributeImagePath,
        };
        temp.push(variant);
        setarticleImage(temp);
        setselectCombinationID(event.target.value);
        if (
          variantvaluemapping?.price !== null &&
          variantvaluemapping?.price !== "" &&
          variantvaluemapping?.price !== undefined
        ) {
          let price = variantvaluemapping?.price?.trim();
          let price1 = price.replace(",", "");

          setCombinationattributeprice(price1);
        } else {
          setCombinationattributeprice(0);
        }
      }
    } else {
      setarticleImage(articleImagetemp);
      setselectCombinationID("");
      setCombinationattributeprice(0);
    }
  };

  const _onselecttext = () => {
    let retval = "Select Combination";
    variantList.map((variantItem, i) => {
      if (i === 0) {
        retval = retval + " " + variantItem.attributeName;
      } else {
        retval = retval + " / " + variantItem.attributeName;
      }
    });
    return retval;
  };
  const reyurnperamiter = (item) => {
    let itemobj = item.split("https://www.youtube.com/watch");
    console.log("item", itemobj);
    return new URLSearchParams(itemobj[1]).get("v");
    //    console.log("IdPraveen=>",ID)
  };
  const YoutublePlayer = (item) => {
    // return (
    // <YouTube videoId={item} opts={opts} />
    // )
    console.log("itemPraveen", item);
  };
  const opts = {
    height: "200",
    width: "280",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  const LoaderSpinner = () => {
    return (
      <div
        className="vh-100"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="">
          <img
            src="../assets/img/LOADINGSCREEN-removebg.png"
            className="loaderimg"
            style={{ height: "700px" }}
          ></img>
        </div>
      </div>
      // <div className="spinner-container">
      //   <div className="loading-spinner"></div>
      // </div>
    );
  };

  const toggleReportabuse = () => {
    setSelectTypeofabuse("Nudity");
    setmodalReportabuse(false);
  };

  const SendAbusereport = async () => {
    let repostvalue = {
      abusereportTypes: SelectTypeofabuse,
      loginEmail: "",
      productlink: locationPath ? locationPath.toString() : "",
      latitude: latitude ? latitude.toString() : "",
      longitude: longitude ? longitude.toString() : "",
    };
    console.log(
      "JSON.stringify(repostvalue)=====>",
      JSON.stringify(repostvalue)
    );
    await postAbusereport(JSON.stringify(repostvalue))
      .then((res) => {
        console.log("res.data:", res);
        if (res === true || res === "true") {
          toggleReportabuse();
          swal("Thanks!", "Your report has been submitted .", {
            icon: "success",
          });
        } else {
          swal("error!", "Your report has been not submitted.", {
            icon: "error",
          });
        }
      })
      .catch((err) => {
        swal("error!", err, {
          icon: "error",
        });
        console.log(err);
      });
  };

  const Oniosclick = () => {
    var deeplinkUrl = "scantotell://";
    var change = false;
    setTimeout(() => {
      if (!change) {
        window.location = Config.iOSUrl;
      }
    }, 1000);
    window.location = deeplinkUrl;
    window.onblur = function () {
      change = true;
    };
    window.onfocus = function () {
      change = false;
    };
  };

  const sendemailmessgae = async (event) => {
    event.preventDefault();
    setCompanyEmailError("");
    if (userchatemail === null && userchatemail.trim() === "" && userchatemail === undefined) {
      setCompanyEmailError("email address required");
      return false;
    }
    else {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userchatemail)) {
        setCompanyEmailError("Invalid email address");
        return false;
      }
    }



    let body = {
      Description: userchatmessage,
      FromUserName: userchatname,
      FromUserEmail: userchatemail,
      TargetID: productinfo?._id,
      TargetType: ProductType,
      ischatsendme: ischatsendme,
      Render: rendername,
      QrCodeID: "",
    };
    await postsendemailchat(JSON.stringify(body))
      .then((res) => {
        console.log("res.data:", res);
        if (res?.issucces === true) {
          setmodalemailchat(false);
          setuserchatemail("");
          setuserchatmessage("");
          setuserchatname("");
          setischatsendme("");
          swal({
            title: "Your message has been sent",
            text: "We shall contact you very soon",
          });
        } else {
          swal("error!", "Your message has been not sent", {
            icon: "error",
          });
        }
      })
      .catch((err) => {
        swal("error!", err, {
          icon: "error",
        });
        console.log(err);
      });
  };
  return (
    <>
      {/* {isfirstloding && LoaderSpinner()} */}
      {isfirstloding === false && isLoading === true ? (
        <>
          <div className="splashbg-change vh-100">
            <div className="logoimgcontainer">
              {BrandingLogoPath !== null &&
                BrandingLogoPath !== "" &&
                BrandingLogoPath !== undefined &&
                isPublishedBarding === true ? (
                <img
                  alt=""
                  src={BrandingLogoPath}
                  className="sttlogo"
                  style={{ height: "80px" }}
                />
              ) : (
                // <img
                //   alt=""
                //   src="../assets/img/logo/Logo_S.jpg"
                //   style={{ height: "80px" }}
                // />
                // <img src="../assets/img/LOADINGSCREEN-removebg.png" className="sttlogo" style={{ height: "80px" }}></img>
                <div className="container-fluid">
                  <div className="loadernew">
                    <h2>Wait Please</h2>
                    {/* <img src="../assets/img/loading.gif" className="gif" /> */}
                    <img src="../assets/img/loadingblack.gif" className="gif" />
                    <div className="logo">
                      <img
                        src="../assets/img/logo/STT-Logo.png"
                        width="20px"
                        height="20px"
                      />
                      <p>STT</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      ) : (


        <div
          // className="bg-change"
          className=""
          style={{
            position: 'relative', minHeight: '100vh', height:'100%' ,backgroundPosition: 'center', backgroundAttachment: 'fixed', backgroundSize: 'cover',
            // position: "relative",
            // minHeight: "100vh",
            backgroundColor: articleProductTheme?.isBackgroundUrl == false ? articleProductTheme?.color2
              ? articleProductTheme?.color2
              : "" : "",
            backgroundImage: articleProductTheme?.isBackgroundUrl == true ? `url(${articleProductTheme?.color2
              ? Config.contentUrl + articleProductTheme?.color2
              : ""
              })` : "",
          }}
        >
          <div className="padding-30">
            <div
              className="container detailpageheader"
              style={{
                backgroundColor: articleProductTheme?.color1
                  ? articleProductTheme?.color1
                  : "",
              }}
            >
              <div className="row align-items-center px-2">
                {WhiteLabellingName !== null &&
                  WhiteLabellingName !== "" &&
                  WhiteLabellingName !== undefined &&
                  isPublishedTagLine === true ? (
                  <h4
                    className="col-xs-6 mb-0"
                    style={{
                      color: articleProductTheme?.color3
                        ? articleProductTheme?.color3
                        : "",
                    }}
                  >
                    {WhiteLabellingName}
                  </h4>
                ) : (
                  <h4
                    className="col-xs-6 mb-0"
                    style={{
                      color: articleProductTheme?.color3
                        ? articleProductTheme?.color3
                        : "",
                    }}
                  >
                    Scan To Tell
                  </h4>
                )}

                <div
                  className="col-xs-6 d-flex align-items-end justify-content-end"
                // onClick={() => { GotoHome() }}
                >
                  {BrandingLogoPath !== null &&
                    BrandingLogoPath !== "" &&
                    BrandingLogoPath !== undefined &&
                    isPublishedBarding === true ? (
                    <img alt="" src={BrandingLogoPath} className="sttlogo" />
                  ) : (
                    <img
                      alt=""
                      src="../assets/img/logo/Logo_S.jpg "
                      className="sttlogo"
                    />
                  )}

                  {/* <h4 className="mb-0 ml-1">STT</h4> */}
                </div>
              </div>
            </div>

            {IsPublished === true ? (
              productinfo?.isCustomerWallet === false ? (
                <>
                  <div className="container-fluid pt-4">
                    <div className="row">
                      <div className="col-md-12">
                        <Slider
                          {...settings}
                          className="mt-5 slider"
                          style={{
                            borderRadius: articleProductTheme?.sliderimground
                              ? articleProductTheme?.sliderimground
                              : "",
                          }}
                        >
                          {articleImage.map((item, i) => {
                            return (
                              <div>
                                {rendername === "Combination" &&
                                  isArticleTypeDisplay === true ? (
                                  <>
                                    {/* <img alt="" src={Config.contentUrl + item} className='sliderImage'
                                                                    onClick={openModal}
                                                                    onError={({ currentTarget }) => {
                                                                        currentTarget.onerror = null; // prevents looping
                                                                        currentTarget.src = "../assets/img/new-images/images.png";
                                                                    }} /> */}
                                    <img
                                      alt=""
                                      src={Config.contentUrl + item}
                                      className="sliderImage"
                                      key={i}
                                      onClick={() => openImageViewer(item, i)}
                                      onerror={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src =
                                          "../assets/img/new-images/images.png";
                                      }}
                                    />
                                  </>
                                ) : isArticleImageDisplay === true ? (
                                  <>
                                    {/* <img alt="" src={Config.contentUrl + item.filePath} className='sliderImage'
                                                                        onError={({ currentTarget }) => {
                                                                            currentTarget.onerror = null; // prevents looping
                                                                            currentTarget.src = "../assets/img/new-images/images.png";
                                                                        }} /> */}
                                    <img
                                      alt=""
                                      src={Config.contentUrl + item.filePath}
                                      className="sliderImage"
                                      // onClick={openModal}
                                      key={i}
                                      onClick={() =>
                                        openImageViewer(item.filePath, i)
                                      }
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src =
                                          "../assets/img/new-images/images.png";
                                      }}
                                    />
                                    {/* {isViewerOpen && (
                                                                            <ImageViewer
                                                                                src={selectImage}
                                                                                currentIndex={currentImage}
                                                                                onClose={closeImageViewer}
                                                                                disableScroll={false}
                                                                                backgroundStyle={{
                                                                                    backgroundColor: "rgba(0,0,0,0.5)"
                                                                                }}
                                                                                closeOnClickOutside={true}
                                                                            />
                                                                        )} */}
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            );
                          })}
                        </Slider>
                        <UncontrolledButtonDropdown className="positionbutton">
                          <DropdownToggle
                            className="btn btn-white rounded-circle shadow-add change-hight"
                            style={{
                              backgroundColor: articleProductTheme?.color1
                                ? articleProductTheme?.color1
                                : "",
                                color: articleProductTheme?.color3 ? articleProductTheme?.color3 : ""
                            }}
                          >
                            <i
                              class="fa fa-ellipsis-v fa-lg"
                              aria-hidden="true"
                            ></i>
                          </DropdownToggle>

                          <DropdownMenu className="DropdownMenu">
                            <DropdownItem
                              className="item"
                              onClick={onclickwallet}
                            >
                              <i class="text-success fa-2x ion ion-md-wallet"></i>
                            </DropdownItem>
                            <DropdownItem className="item">
                              <RWebShare
                                data={{
                                  url:
                                    Config.FrontUrl +
                                    "productdetails" +
                                    location,
                                }}
                                onClick={() =>
                                  console.log("shared successfully!")
                                }
                              >
                                <i class="text-gray fa-2x ion ion-md-share"></i>
                              </RWebShare>
                            </DropdownItem>

                            <DropdownItem
                              className="item"
                              onClick={() =>
                                toggleqrcode(
                                  Config.FrontUrl + "productdetails" + location
                                )
                              }
                            >
                              <i
                                class="fa-qrcode fas iconheight"
                                style={{
                                  fontSize: "22px",
                                  color: "#000",
                                }}
                              ></i>
                            </DropdownItem>

                            <DropdownItem
                              className="item"
                              onClick={togglesizetable}
                            >
                              <i
                                class="ion ion-md-list-box"
                                style={{
                                  fontSize: "22px",
                                  color: "rgb(87, 134, 252)",
                                }}
                              ></i>
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledButtonDropdown>
                        <Modal
                          isOpen={modalqrcode}
                          toggle={toggleqrcode}
                          className="modalcenter text-center mx-5"
                        >
                          <ModalBody>
                            <div>
                              {QrCodeString !== null ? (
                                // <QRCode value={QrCodeString} id="qrCodeEl" size={240} />
                                <QRCode
                                  value={QrCodeString}
                                  id="DetailsE1"
                                  size={210}
                                />
                              ) : (
                                <img
                                  alt=""
                                  src="/assets/img/user/QR.png"
                                  style={{ width: "160px" }}
                                />
                              )}
                            </div>
                            <div className="container mt-2">
                              <div className="row justify-content-center">
                                <div className="col-xs-12 text-center">
                                  <button
                                    type="submit"
                                    className="btn btn-primary w-250"
                                    onClick={downloadQrCodeImage}
                                  // onClick={() => { downloadQrCodeImage() }}
                                  >
                                    <p className="mb-0">Download</p>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <button
                              className="btn btn-link modalcolsebtn"
                              onClick={toggleqrcode}
                            >
                              <i className="fa-2x ion ion-md-close-circle"></i>
                            </button>
                          </ModalBody>
                        </Modal>
                        <Modal
                          isOpen={modalMobileStore}
                          toggle={toggleMobileStore}
                          className="modalcenter text-center mx-5"
                        >
                          <ModalBody>
                            <div className="text-center">
                              <p className="mx-2">
                                Please install our <br></br>STT smart App to
                                complete <br></br>this task
                              </p>
                              <div className="text-center">
                                <div>
                                  {isAndroid ? (
                                    <div className="mb-2">
                                      <img
                                        src="../assets/img/googleplaystore.png"
                                        width={"55%"}
                                        height={"55%"}
                                        onClick={() => {
                                          window.open(
                                            Config.androidUrl,
                                            "_blank"
                                          );
                                        }}
                                      />
                                    </div>
                                  ) : isIOS ? (
                                    <div className="mb-2">
                                      <img
                                        src="../assets/img/Ios.png"
                                        width={"50%"}
                                        height={"50%"}
                                        onClick={() => {
                                          Oniosclick();
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div className="mb-2">
                                      <img
                                        src="../assets/img/website.png"
                                        width={"50%"}
                                        height={"50%"}
                                        onClick={() => {
                                          window.open(
                                            Config.FrontUrl,
                                            "_blank"
                                          );
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>

                                <button
                                  type="button"
                                  class="btn btn-primary btn-sm shadow-add"
                                  onClick={() => {
                                    window.open(Config.videolink, "_blank");
                                  }}
                                >
                                  <p className="mb-0 subcollapse">
                                    Watch App intro video
                                  </p>
                                </button>
                              </div>
                            </div>
                            <button
                              className="btn btn-link modalcolsebtn"
                              onClick={toggleMobileStore}
                            >
                              <i className="fa-2x ion ion-md-close-circle"></i>
                            </button>
                          </ModalBody>
                        </Modal>

                        <Modal
                          isOpen={modalsizetable}
                          toggle={togglesizetable}
                          className="text-center mt-5"
                        >
                          <ModalBody>
                            <h3>Size Table</h3>
                            <div>
                              <img
                                alt=""
                                src={Config.contentUrl + productinfo?.sizeTabel}
                                className="my-3 sliderImage"
                                style={{ width: "200px" }}
                              />
                            </div>

                            <button
                              className="btn btn-link modalcolsebtn"
                              onClick={togglesizetable}
                            >
                              <i className="fa-2x ion ion-md-close-circle"></i>
                            </button>
                          </ModalBody>
                        </Modal>
                      </div>
                    </div>
                  </div>
                  <div className="container-fluid mb-2 mt-1">
                    <div className="row align-items-center">
                      <div className="col-xs-8" style={{ fontSize: "24px" }}>
                        {isNameAndCatDisplay === true ? (
                          <h2
                            className="text-black1 mb-1"
                            style={{ color: articleProductTheme?.color3 ? articleProductTheme?.color3 : "" }}
                          // style={{
                          //   fontSize: articleProductTheme?.titlefontsize,
                          // }}

                          >
                            {ArticleName}
                          </h2>
                        ) : (
                          <></>
                        )}
                        {isPriceDisplay === true ? (
                          selectCombinationID !== null &&
                            selectCombinationID !== "" &&
                            selectCombinationID !== undefined ? (
                            <p className="text-black mb-0" style={{ color: articleProductTheme?.color3 ? articleProductTheme?.color3 : "" }}>
                              {parseFloat(Combinationattributeprice) >
                                parseFloat(0) ? (
                                <NumericFormat
                                  prefix={
                                    productinfo?.currencyDetail?.otherName
                                      ? productinfo?.currencyDetail?.otherName
                                      : ""
                                  }
                                  displayType="text"
                                  thousandSeparator={true}
                                  className=""
                                  placeholder="Regular Price"
                                  decimalScale={2}
                                  fixedDecimalScale={false}
                                  value={Combinationattributeprice}
                                />
                              ) : productinfo?.sellPrice !== 0 ? (
                                <>
                                  <div className="row relatedspantag-main">
                                    <p
                                      className="text-black text-decoration-line-through mr-2 relatedspantag"
                                      style={{ color: articleProductTheme?.color3 ? articleProductTheme?.color3 : "" }}
                                    >
                                      <NumericFormat
                                        prefix={
                                          productinfo?.currencyDetail?.otherName
                                            ? productinfo?.currencyDetail
                                              ?.otherName
                                            : ""
                                        }
                                        displayType="text"
                                        thousandSeparator={true}
                                        className=""
                                        placeholder="Regular Price"
                                        decimalScale={2}
                                        fixedDecimalScale={false}
                                        value={productinfo?.regularPrice}
                                      />
                                    </p>
                                    <p className="text-red relatedspantag">
                                      <NumericFormat
                                        prefix={
                                          productinfo?.currencyDetail?.otherName
                                            ? productinfo?.currencyDetail
                                              ?.otherName
                                            : ""
                                        }
                                        displayType="text"
                                        thousandSeparator={true}
                                        className=""
                                        placeholder="Regular Price"
                                        decimalScale={2}
                                        fixedDecimalScale={false}
                                        value={productinfo?.sellPrice}
                                      />
                                    </p>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </p>
                          ) : productinfo?.sellPrice !== 0 ? (
                            <>
                              <div className="row relatedspantag-main">
                                <p className="text-decoration-line-through mb-0 mr-2 relatedspantag" style={{ color: articleProductTheme?.color3 ? articleProductTheme?.color3 : "" }}>
                                  <NumericFormat
                                    prefix={
                                      productinfo?.currencyDetail?.otherName
                                        ? productinfo?.currencyDetail?.otherName
                                        : ""
                                    }
                                    displayType="text"
                                    thousandSeparator={true}
                                    className=""
                                    placeholder="Regular Price"
                                    decimalScale={2}
                                    fixedDecimalScale={false}
                                    value={productinfo?.regularPrice}
                                  />
                                </p>
                                <p className="text-red relatedspantag">
                                  <NumericFormat
                                    prefix={
                                      productinfo?.currencyDetail?.otherName
                                        ? productinfo?.currencyDetail?.otherName
                                        : ""
                                    }
                                    displayType="text"
                                    thousandSeparator={true}
                                    className=""
                                    placeholder="Regular Price"
                                    decimalScale={2}
                                    fixedDecimalScale={false}
                                    value={productinfo?.sellPrice}
                                  />
                                </p>
                              </div>
                            </>
                          ) : (
                            <p className="mb-0" style={{ color: articleProductTheme?.color3 ? articleProductTheme?.color3 : "" }}>
                              <NumericFormat
                                prefix={
                                  productinfo?.currencyDetail?.otherName
                                    ? productinfo?.currencyDetail?.otherName
                                    : ""
                                }
                                displayType="text"
                                thousandSeparator={true}
                                className=""
                                placeholder="Regular Price"
                                decimalScale={2}
                                fixedDecimalScale={false}
                                value={productinfo?.regularPrice?.toFixed(2)}
                              />
                            </p>
                          )
                        ) : (
                          <></>
                        )}
                      </div>
                      {isPublishedLogo === true ? (
                        <>
                          <div className="col-xs-4 text-right">
                            <button className="btn btn-link">
                              {productLogoPath !== null &&
                                productLogoPath !== "" &&
                                productLogoPath !== undefined ? (
                                <img
                                  alt=""
                                  src={Config.contentUrl + productLogoPath}
                                  className="rounded text-center f-s-20 height-70 width-70"
                                  style={{
                                    // boxShadow: articleProductTheme?.logoshadow
                                    //   ? articleProductTheme?.logoshadow +
                                    //     " " +
                                    //     articleProductTheme?.logoshadow +
                                    //     " " +
                                    //     articleProductTheme?.logoshadow
                                    //   : "",
                                  }}
                                  onError={({ currentTarget }) => {
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src =
                                      "../assets/img/new-images/images.png";
                                  }}
                                />
                              ) : (
                                <img
                                  alt=""
                                  src="../assets/img/new-images/images.png"
                                  className="rounded text-center f-s-20 height-70 width-70"
                                  style={{
                                    boxShadow: articleProductTheme?.logoshadow
                                      ? articleProductTheme?.logoshadow +
                                      " " +
                                      articleProductTheme?.logoshadow +
                                      " " +
                                      articleProductTheme?.logoshadow
                                      : "",
                                  }}
                                />
                              )}
                            </button>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <div className="container-fluid" style={{marginLeft:'10px', width:'94%'}}>
                    <div className="row">
                      {isArticleTypeDisplay === true ? (
                        <>
                          <label className="col-form-label">
                            {_onselecttext()}
                          </label>
                          <select
                            className="form-control default-select2"
                            value={selectCombinationID}
                            onChange={(e) => {
                              selectvariant(e);
                            }}
                            disabled={
                              selectCombinationdisabled === true ? true : false
                            }
                          >
                            <option value="0" selected>
                              --- Select Combination ---
                            </option>
                            {productinfo?.attributeValueMappingList.map(
                              (item) => {
                                // <option value={item.id}>{item.attributeValue1 + "/" + item.attributeValue2 + `$'/++"`}</option>
                                return item.attributeValue1 != "" &&
                                  item.attributeValue2 != "" &&
                                  item.attributeValue3 != "" &&
                                  item.attributeValue4 != "" &&
                                  item.attributeValue5 != "" ? (
                                  <option value={item._id}>
                                    {item.attributeValue1 +
                                      " / " +
                                      item.attributeValue2 +
                                      " / " +
                                      item.attributeValue3 +
                                      " / " +
                                      item.attributeValue4 +
                                      " / " +
                                      item.attributeValue5}
                                  </option>
                                ) : item.attributeValue1 != "" &&
                                  item.attributeValue2 != "" &&
                                  item.attributeValue3 != "" &&
                                  item.attributeValue4 != "" &&
                                  item.attributeValue5 === "" ? (
                                  <option value={item._id}>
                                    {item.attributeValue1 +
                                      " / " +
                                      item.attributeValue2 +
                                      " / " +
                                      item.attributeValue3 +
                                      " / " +
                                      item.attributeValue4}
                                  </option>
                                ) : item.attributeValue1 != "" &&
                                  item.attributeValue2 != "" &&
                                  item.attributeValue3 != "" &&
                                  item.attributeValue4 === "" &&
                                  item.attributeValue5 === "" ? (
                                  <option value={item._id}>
                                    {item.attributeValue1 +
                                      " / " +
                                      item.attributeValue2 +
                                      " / " +
                                      item.attributeValue3}
                                  </option>
                                ) : item.attributeValue1 != "" &&
                                  item.attributeValue2 != "" &&
                                  item.attributeValue3 === "" &&
                                  item.attributeValue4 === "" &&
                                  item.attributeValue5 === "" ? (
                                  <option value={item._id}>
                                    {item.attributeValue1 +
                                      " / " +
                                      item.attributeValue2}
                                  </option>
                                ) : item.attributeValue1 != "" &&
                                  item.attributeValue2 === "" &&
                                  item.attributeValue3 === "" &&
                                  item.attributeValue4 === "" &&
                                  item.attributeValue5 === "" ? (
                                  <option value={item._id}>
                                    {item.attributeValue1}
                                  </option>
                                ) : (
                                  <></>
                                );
                              }
                            )}
                          </select>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

                  <div className="container-fluid mb-3">
                    <div className="row mt-4">
                      <div className="col-md-12">
                        <div
                          className="card ckeditor-text ckeditor-theme px-2"
                          style={{
                            backgroundColor: articleProductTheme?.color1
                              ? articleProductTheme?.color1
                              : "",
                            borderColor: articleProductTheme?.color1
                              ? articleProductTheme?.color1
                              : "",
           
                            overflowX: "scroll",
                            padding: "15px",
                            background: "white",
                            borderWidth: "4px",
                          }}
                        >
                          {isShortDescriptionDisplay === true ? (
                            shortDescription !== null &&
                            shortDescription !== "" && (
                              <div className="ckeditor-text-new">
                                {renderHTML(shortDescription)}
                              </div>
                            )
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {isArticleDescriptionDisplay === true ? (
                    articleSegmentList.length > 0 ? (
                      articleSegmentList.map((Item, i) => {
                        return (
                          <div className="container-fluid">
                            {Item.articleSegmentImageList.length > 0 ||
                              Item.articleVideoList.length > 0 ||
                              Item.articleDocumentList.length > 0 ||
                              Item.articleExternalLinkList.length > 0 ||
                              Item.description?.length > 0 ? (
                              <div className="row">
                                <div className="col-xl-12">
                                  <button
                                    className="collapsebutton collapseshadow btn btn-white mt-2"
                                    type="button"
                                    data-toggle="collapse"
                                    data-target={"#collapseExample" + Item._id}
                                    aria-expanded="false"
                                    aria-controls="collapseExample"
                                    style={{
                                      backgroundColor:
                                        articleProductTheme?.color1
                                          ? articleProductTheme?.color1
                                          : "",
                                    }}
                                  >
                                    <p
                                      className="text-break maincollapse mb-0"
                                      style={{
                                        color: articleProductTheme?.color3
                                          ? articleProductTheme?.color3
                                          : "",
                                      }}
                                    >
                                      {Item.title}
                                    </p>
                                    <i
                                      className="fa-angle-down fa-fw fa-lg fas me-10px"
                                      style={{
                                        color: articleProductTheme?.color3
                                          ? articleProductTheme?.color3
                                          : "",
                                      }}
                                    ></i>
                                  </button>
                                  <div
                                    className="collapse"
                                    id={"collapseExample" + Item._id}
                                  >
                                    {Item.articleSegmentImageList.length > 0 ? (
                                      <div className="row mt-4">
                                        <div className="col-md-12">
                                          <Slider
                                            {...settings}
                                            className="subslider"
                                          >
                                            {Item.articleSegmentImageList
                                              .length > 0 &&
                                              Item.isArticleSegmentImageDisplay ===
                                              true
                                              ? Item.articleSegmentImageList.map(
                                                (subItem, i) => {
                                                  return (
                                                    <div>
                                                      <img
                                                        alt=""
                                                        src={
                                                          Config.contentUrl +
                                                          subItem.filePath
                                                        }
                                                        key={i}
                                                        className="sliderImage"
                                                        onClick={() =>
                                                          subopenImageViewer(
                                                            Item,
                                                            i
                                                          )
                                                        }
                                                        // onClick={(e) => { opencollapseslidermodal(Item.articleSegmentImageList) }}
                                                        onError={({
                                                          currentTarget,
                                                        }) => {
                                                          currentTarget.onerror =
                                                            null; // prevents looping
                                                          currentTarget.src =
                                                            "../assets/img/new-images/images.png";
                                                        }}
                                                      />
                                                    </div>
                                                  );
                                                }
                                              )
                                              : null}
                                          </Slider>
                                        </div>
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                    {Item?.description !== null &&
                                      Item?.description !== "" &&
                                      Item.isArticleSegmentDescriptionDisplay ===
                                      true ? (
                                      <div
                                        className="container-fluid card ckeditor-theme mt-2"
                                        style={{
                                          backgroundColor:
                                            articleProductTheme?.color1
                                              ? articleProductTheme?.color1
                                              : "",
                                          borderColor:
                                            articleProductTheme?.color1
                                              ? articleProductTheme?.color1
                                              : "",
                                       
                                          overflowX: "scroll",
                                          padding: "15px",
                                          fontSizeAdjust: "26px",
                                          background: "white",
                                          borderWidth: "4px",
                                        }}
                                      >
                                        <div className="row mt-4">
                                          <p className="col-md-12 text-break">
                                            {Item.isArticleSegmentDescriptionDisplay ===
                                              true ? (
                                              Item?.description !== null &&
                                              Item?.description !== "" && (
                                                <div className="ckeditor-text-new">
                                                  {renderHTML(Item.description)}
                                                </div>
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                    ) : (
                                      <></>
                                    )}

                                    <div className="container-fluid px-0">
                                      <div className="row px-1">
                                        {Item.articleVideoList.length > 0 &&
                                          Item.isArticleSegmentVideoDisplay ===
                                          true ? (
                                          <div
                                            className="col-md-12 mt-2 transparent-ckeditor-theme"
                                            style={{
                                              backgroundColor: "transparent",
                                            
                                              overflowX: "scroll",
                                            }}
                                          >
                                            <div
                                              className={
                                                "collapse subsection show"
                                              }
                                              id={"detailknowmore" + Item._id}
                                            >
                                              <div className="row mt-4">
                                                {Item.articleVideoList.length >
                                                  0
                                                  ? Item.articleVideoList.map(
                                                    (subItem) =>
                                                      subItem.isYouTubeLink ===
                                                        false ? (
                                                        <>
                                                          <div className="col-xs-6 text-center">
                                                            <button
                                                              className="btn btn-link bg-transparent p-0 videotag"
                                                              onClick={() => {
                                                                setOtherYouTubeLink(
                                                                  Config.contentUrl +
                                                                  subItem.filePath
                                                                );
                                                                // setOpen(true)
                                                                setTimeout(
                                                                  () => {
                                                                    setOpen(
                                                                      true
                                                                    );
                                                                  },
                                                                  300
                                                                );
                                                              }}
                                                            >
                                                              <VideoTag
                                                                src={
                                                                  Config.contentUrl +
                                                                  subItem.filePath
                                                                }
                                                                className="image-article imageUploaddetailpage"
                                                              />
                                                              <p className="breakword text2line videotagtext">
                                                                {
                                                                  subItem.originalFileName
                                                                }
                                                              </p>

                                                              <div className="youtubeicon">
                                                                <i className="fa-fw fa-lg fa-youtube fab"></i>
                                                              </div>
                                                            </button>
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <>
                                                          <div className="col-xs-6 text-center">
                                                            <button
                                                              className="btn btn-link bg-transparent p-0 videotag"
                                                              onClick={() => {
                                                                setOtherYouTubeLink(
                                                                  ""
                                                                );
                                                                toggleVideoPlayer(
                                                                  reyurnperamiter(
                                                                    subItem?.youTubeLink
                                                                  )
                                                                );
                                                              }}
                                                            >
                                                              <img
                                                                src={`https://i.ytimg.com/vi/${reyurnperamiter(
                                                                  subItem?.youTubeLink
                                                                )}/hqdefault.jpg`}
                                                                className="image-article imageUploaddetailpage"
                                                              />
                                                              <p className="breakword text2line videotagtext">
                                                                {
                                                                  subItem.youTubeLink
                                                                }
                                                              </p>

                                                              <div className="youtubeicon">
                                                                <i className="fa-fw fa-lg fa-youtube fab"></i>
                                                              </div>
                                                            </button>
                                                          </div>
                                                        </>
                                                      )
                                                  )
                                                  : null}
                                              </div>
                                            </div>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                        {Item.articleDocumentList.length > 0 &&
                                          Item.isArticleSegmentDocumentDisplay ===
                                          true ? (
                                          <div
                                            className="col-md-12 mt-2 transparent-ckeditor-theme"
                                            style={{
                                              backgroundColor: "transparent",
                                           
                                              overflowX: "scroll",
                                            }}
                                          >
                                            <div
                                              className={
                                                "collapse subsection show"
                                              }
                                              id={
                                                "detailreadfurther" + Item._id
                                              }
                                            >
                                              <div className="row mt-4">
                                                {Item.articleDocumentList
                                                  .length > 0
                                                  ? Item.articleDocumentList.map(
                                                    (subItem) => {
                                                      return (
                                                        <div className="col-xs-6 text-center">
                                                          <button
                                                            className="collapseshadow btn btn-white image-button"
                                                            onClick={(e) => {
                                                              downloadImage(
                                                                subItem.filePath,
                                                                subItem.originalFileName
                                                              );
                                                            }}
                                                          >
                                                            <img
                                                              alt=""
                                                              // src="/assets/img/new-Images/pdf.png"
                                                              src={
                                                                Config.contentUrlApi +
                                                                "Frontend/pdf.png"
                                                              }
                                                              className="pdfimages"
                                                            />
                                                          </button>
                                                          <div className="row">
                                                            <h5 className="col-md-12 mt-2 text2line wordbreak">
                                                              {
                                                                subItem.originalFileName
                                                              }
                                                            </h5>
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                  )
                                                  : null}
                                              </div>
                                            </div>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                        {Item.articleExternalLinkList.length >
                                          0 &&
                                          Item.isArticleSegmentWebLinkDisplay ===
                                          true ? (
                                          <div
                                            className="col-md-12 mt-2"
                                            style={{
                                              backgroundColor: "transparent",
                                            }}
                                          >
                                            <div
                                              className={
                                                "collapse subsection  show"
                                              }
                                              id={
                                                "detailexplorefurther" +
                                                Item._id
                                              }
                                            >
                                              <div className="row">
                                                {Item.articleExternalLinkList
                                                  .length > 0
                                                  ? Item.articleExternalLinkList.map(
                                                    (subItem) => {
                                                      return (
                                                        <div
                                                          className="col-xs-12 mt-2"
                                                          style={{
                                                            backgroundColor:
                                                              "transparent",
                                                            display: "flex",
                                                            justifyContent:
                                                              "center",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <div className="linkmain-btn">
                                                            {subItem.name ? (
                                                              <button
                                                                className="btn"
                                                                onClick={() =>
                                                                  OpenExternallink(
                                                                    subItem.linkURL
                                                                  )
                                                                }
                                                              >
                                                                {subItem.name}
                                                              </button>
                                                            ) : (
                                                              <></>
                                                            )}
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                  )
                                                  : null}
                                              </div>
                                            </div>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        );
                      })
                    ) : null
                  ) : (
                    <></>
                  )}
                  {isCertificateDisplay === true ? (
                    articleCertificates.length > 0 ? (
                      <>
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-md-12 mt-2">
                              <button
                                className="collapsebutton collapseshadow btn btn-white"
                                type="button"
                                data-toggle="collapse"
                                data-target="#certificates"
                                aria-expanded="false"
                                aria-controls="certificates"
                                style={{
                                  backgroundColor: articleProductTheme?.color1
                                    ? articleProductTheme?.color1
                                    : "",
                                }}
                              >
                                <p
                                  className="maincollapse mb-0"
                                  style={{
                                    color: articleProductTheme?.color3
                                      ? articleProductTheme?.color3
                                      : "",
                                  }}
                                >
                                  Certificates
                                </p>
                                <i
                                  className="fa-angle-down fa-fw fa-lg fas me-10px"
                                  style={{
                                    color: articleProductTheme?.color3
                                      ? articleProductTheme?.color3
                                      : "",
                                  }}
                                ></i>
                              </button>
                              <div
                                className="collapse subsection"
                                id="certificates"
                              >
                                <div className="row">
                                  {articleCertificates.length > 0
                                    ? articleCertificates.map((Item, i) => {
                                      return (
                                        <>
                                          {" "}
                                          <div className="col-xs-6 text-center mt-3">
                                            <button
                                              className="collapseshadow btn btn-white image-button"
                                              onClick={() =>
                                                toggleCertificateimg(Item)
                                              }
                                            >
                                              <img
                                                alt=""
                                                src={
                                                  Config.contentUrl +
                                                  Item._LogoPath
                                                }
                                                onError={({
                                                  currentTarget,
                                                }) => {
                                                  currentTarget.onerror =
                                                    null; // prevents looping
                                                  currentTarget.src =
                                                    "../assets/img/new-images/images.png";
                                                }}
                                              />
                                            </button>
                                            <div className="row">
                                              <h5 className="col-md-12 mt-2 wordbreak">
                                                {Item.name}
                                              </h5>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    })
                                    : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <Modal
                          isOpen={modalCertificateimg}
                          toggle={toggleCertificateimg}
                          className="modalcenter text-center"
                        >
                          <ModalBody>
                            <div>
                              <img
                                alt=""
                                src={
                                  Config.contentUrl + CirtificateItem._LogoPath
                                }
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null; // prevents looping
                                  currentTarget.src =
                                    "../assets/img/new-images/images.png";
                                }}
                                className="certificateimg"
                              />
                              {/* <img alt="" src="/assets/img/new-Images/Certificates-1.png" className='certificateimg' /> */}
                            </div>
                            <div className="container mt-2">
                              <div className="row justify-content-center">
                                {CirtificateItem?.documentPath?.length > 0 ? (
                                  <div className="col-md-7">
                                    <button
                                      type="button"
                                      style={{ backgroundColor: "#5786fc" }}
                                      className="btn modalbtn"
                                      onClick={(e) => {
                                        downloadCirtificatepdgf(
                                          CirtificateItem.documentPath,
                                          CirtificateItem.documentUserName
                                        );
                                      }}
                                    >
                                      <i className="fa-file fas"></i>
                                      <p className="mb-0">Document</p>
                                    </button>
                                  </div>
                                ) : (
                                  <></>
                                )}
                                {CirtificateItem?.website?.length > 0 ? (
                                  <div className="col-md-7">
                                    <button
                                      type="button"
                                      style={{ backgroundColor: "#fe507f" }}
                                      className="btn modalbtn"
                                      onClick={() =>
                                        OpenCertificateExternallink(
                                          CirtificateItem?.website
                                        )
                                      }
                                    >
                                      <i className="ion ion-md-globe"></i>
                                      <p className="mb-0">Website</p>
                                    </button>
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            <button
                              className="btn btn-link modalcolsebtn"
                              onClick={toggleCertificateimg}
                            >
                              <i className="fa-2x ion ion-md-close-circle"></i>
                            </button>
                          </ModalBody>
                        </Modal>
                      </>
                    ) : (
                      <></>
                    )
                  ) : (
                    <></>
                  )}
                  {productinfo?.isRelatedProductDisplay === true ? (
                    <div className="container-fluid mt-2" >
                      <div
                        className="row align-items-center mb-2"
                        type="button"
                      >
                        <h4 className="col-xs-6 mb-0">Related Products</h4>
                        <div className="col-xs-6 text-right">
                          <button
                            className="btn btn-link"
                            type="button"
                            onClick={() => {
                              onclickwallet();
                            }}
                          >
                            <h5
                              className="mb-0 weblinktext"
                              style={{ color: "#2672ec" }}
                            >
                              See More
                            </h5>
                          </button>
                        </div>
                      </div>
                      {relatedproduct.length > 0 && relatedproduct != null ? (
                        <Slider {...settings2} className="reletedprodslider">
                          {relatedproduct.map((Item, i) => {
                            return (
                              <button className="btn" style={{ backgroundColor: 'transparent' }}>
                                <img
                                  alt=""
                                  src={
                                    Config.contentUrl + Item.relatedproductImage
                                  }
                                  className="sliderImage"
                                  onError={({ currentTarget }) => {
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src =
                                      "../assets/img/new-images/images.png";
                                  }}
                                />

                                <h5 className="text-left mb-0 mt-3">
                                  {Item.relatedproductName}
                                </h5>
                                {/* <p className='text-black mb-0' ><span className='relatedspantag' style={{ color: 'gray' }}> $ {Item.relatedproductRegularPrice}</span> $ {Item.relatedproductRegularPrice}</p> */}

                                {/* {
                                  Item?.relatedproductSellPrice !== 0 || Item?.relatedproductSellPrice !== "0" && Item?.relatedproductSellPrice > 0 ?
                                    <>
                                      <p className='text-black mb-0' ><span className='relatedspantag' style={{ color: 'gray' }}>  {Item.currencySymbol} {Item.relatedproductRegularPrice}</span> {" "} {Item.currencySymbol} {Item.relatedproductSellPrice}</p>
                                    </>
                                    : Item?.relatedproductRegularPrice !== 0 || Item?.relatedproductRegularPrice !== "0" && Item?.relatedproductRegularPrice > 0 ? <><p className='text-black mb-0' ><span className='relatedspantag' style={{ color: 'gray' }}> {Item.currencySymbol} {Item.relatedproductRegularPrice}</span></p></>
                                      : <></>
                                } */}
                              </button>
                            );
                          })}
                        </Slider>
                      ) : (
                        <></>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                  {isClickToConnectNow === true ? (
                    <>
                      {/* <div className="container-fluid mt-3">
                        <div className="row justify-content-center pb-3">
                          <button
                            type="button"
                            class="btn mb-1 me-1"
                            style={{
                              backgroundColor: articleProductTheme?.color1
                                ? articleProductTheme?.color1
                                : "",
                              color: articleProductTheme?.color3
                                ? articleProductTheme?.color3
                                : "",
                            }}
                            onClick={toggleMobileStore}
                          >
                            Click to Connect now!
                          </button>
                        </div>
                      </div> */}
                      <div className="container-fluid mt-3">
                        <div className="row justify-content-center pb-3">
                          <button
                            type="button"
                            class="btn btn-success shadow-add mb-1 me-1"
                            style={{
                              backgroundColor: articleProductTheme?.color1
                                ? articleProductTheme?.color1
                                : "",
                              color: articleProductTheme?.color3
                                ? articleProductTheme?.color3
                                : "",
                            }}

                            onClick={() => { toggleemailChat() }}
                          >
                            Click to Connect now !
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  <div className="container-fluid pt-4">
                    <div className="row">
                      <div className="col-md-12">
                        <Slider {...settings} className="slider">
                          {articleImage.map((item, i) => {
                            return (
                              <div>
                                {rendername === "Combination" &&
                                  isArticleTypeDisplay === true ? (
                                  <>
                                    <img
                                      alt=""
                                      src={Config.contentUrl + item}
                                      className="sliderImage"
                                      key={i}
                                      onClick={() => openImageViewer(item, i)}
                                      onerror={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src =
                                          "../assets/img/new-images/images.png";
                                      }}
                                    />
                                  </>
                                ) : isArticleImageDisplay === true ? (
                                  <>
                                    <img
                                      alt=""
                                      src={Config.contentUrl + item.filePath}
                                      className="sliderImage"
                                      // onClick={openModal}
                                      key={i}
                                      onClick={() =>
                                        openImageViewer(item.filePath, i)
                                      }
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src =
                                          "../assets/img/new-images/images.png";
                                      }}
                                    />
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            );
                          })}
                        </Slider>
                      </div>
                    </div>
                  </div>
                  <div className="container-fluid mb-2 mt-1">
                    <div className="row align-items-center">
                      <div className="col-xs-8">
                        <h2
                          className="text-black mb-2"
                          style={{
                            color: articleProductTheme?.color3
                              ? articleProductTheme?.color3
                              : "",
                            fontSize: "24px",
                          }}
                        >
                          {ArticleName}
                        </h2>
                        {productinfo?.sellPrice !== 0 ? (
                          <>
                            <p
                              className="text-black mb-0"
                              style={{
                                color: articleProductTheme?.color3
                                  ? articleProductTheme?.color3
                                  : "",
                              }}
                            >
                              {productinfo?.currencyDetail?.otherName +
                                " " +
                                productinfo?.regularPrice.toFixed(2)}
                            </p>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                      {isPublishedLogo === true ? (
                        <div className="col-xs-4 text-right">
                          <button className="btn btn-link">
                            {productLogoPath !== null &&
                              productLogoPath !== "" &&
                              productLogoPath !== undefined ? (
                              <img
                                alt=""
                                src={Config.contentUrl + productLogoPath}
                                className="rounded shadow-add text-center f-s-20 height-70 width-70"
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null; // prevents looping
                                  currentTarget.src =
                                    "../assets/img/new-images/images.png";
                                }}
                              />
                            ) : (
                              <img
                                alt=""
                                src="../assets/img/new-images/images.png"
                                className="rounded shadow-add text-center f-s-20 height-70 width-70"
                              />
                            )}
                          </button>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  {productinfo.remarks.length > 0 ? (
                    <div className="container-fluid">
                      <h2 className="text-black mb-1">Remarks</h2>
                      <p>{productinfo.remarks}</p>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="container-fluid">
                    <div className="row mt-4">
                      <div className="col-md-12">
                        <Slider {...settings} className="subslider">
                          {articleSegmentList.length > 0
                            ? articleSegmentList[0].articleDocumentList.map(
                              (subItem, i) =>
                                subItem.fileExtension === ".pdf" ? (
                                  <div className="align-self-center text-center">
                                    <button
                                      className="btn image-button"
                                      onClick={(e) => {
                                        downloadImage(
                                          subItem.filePath,
                                          subItem.originalFileName
                                        );
                                      }}
                                    >
                                      {/* <button className="btn btn-link" onClick={(e) => { downloadImage(subItem.filePath, subItem.originalFileName) }}> */}
                                      <img
                                        alt=""
                                        src="/assets/img/new-Images/pdf.png"
                                        className="pdfimages"
                                      />
                                    </button>
                                    <div className="row">
                                      <h5 className="col-md-12 mt-2 wordbreak">
                                        {subItem.originalFileName}
                                      </h5>
                                      {/* <p className='subcollapse'>{subItem.originalFileName}</p> */}
                                    </div>
                                  </div>
                                ) : (
                                  <div>
                                    <img
                                      alt=""
                                      src={
                                        Config.contentUrl + subItem.filePath
                                      }
                                      key={i}
                                      className="sliderImage"
                                      onClick={() =>
                                        subopenDocumentViewer(
                                          articleSegmentList[0]
                                            .articleDocumentList,
                                          i
                                        )
                                      }
                                      // onClick={(e) => { opencollapseslidermodal(Item.articleSegmentImageList) }}
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src =
                                          "../assets/img/new-images/images.png";
                                      }}
                                    />
                                  </div>
                                )
                            )
                            : null}
                        </Slider>
                      </div>
                    </div>
                  </div>
                </>
              )
            ) : (
              IsPublished === false &&
              isLoading === false && (
                <div className="container">
                  <div
                    className="d-flex justify-content-center splashbg-change"
                    style={{ position: "relative" }}
                  >
                    <div className="">
                      <p className="m-t-10 bold h3 mx-2">
                        Sorry the owner has stop the publishing
                      </p>
                      <img
                        alt=""
                        src="../assets/img/STT_UnPublish-removebg-preview.png"
                      />
                    </div>
                  </div>
                </div>
              )
            )}
          </div>

          <Productdetailsfooter
            onClick={(e) => {
              setmodalReportabuse(true);
            }}
          ></Productdetailsfooter>
        </div>
      )}
      {isViewerOpen && (
        <ImageViewer
          // src={Config.contentUrl + selectImage}
          src={selectImage}
          currentIndex={currentImage}
          onClose={closeImageViewer}
          backgroundStyle={{
            backgroundColor: "rgba(0,0,0,0.7)",
          }}
          closeOnClickOutside={true}
        />
      )}
      {subisViewerOpen && (
        <ImageViewer
          src={subselectImage}
          currentIndex={subcurrentImage}
          onClose={subcloseImageViewer}
          backgroundStyle={{
            backgroundColor: "rgba(0,0,0,0.7)",
          }}
          closeOnClickOutside={true}
        />
      )}
      {docisViewerOpen && (
        <ImageViewer
          src={subselectDocument}
          currentIndex={subcurrentDocument}
          onClose={subcloseDocumentViewer}
          backgroundStyle={{
            backgroundColor: "rgba(0,0,0,0.7)",
          }}
          closeOnClickOutside={true}
        />
      )}

      <Modal
        isOpen={modalReportabuse}
        toggle={toggleReportabuse}
        className="modalcenter text-center"
      >
        <ModalBody>
          <div className="">
            <div className="modal-typeofabuse">
              <h4>
                <b className="mb-2 mx-2">Type of abuse</b>
              </h4>
              <div
                className="radio"
                onClick={() => {
                  setSelectTypeofabuse("Nudity");
                }}
              >
                <input
                  type="radio"
                  value="Nudity"
                  checked={SelectTypeofabuse === "Nudity"}
                  onChange={() => {
                    setSelectTypeofabuse("Nudity");
                  }}
                />
                <label className="mr-2">Nudity</label>
              </div>
              <div
                className="radio"
                onClick={() => {
                  setSelectTypeofabuse("Copyright infringement");
                }}
              >
                <input
                  type="radio"
                  value="Copyright infringement"
                  checked={SelectTypeofabuse === "Copyright infringement"}
                  onChange={() => {
                    setSelectTypeofabuse("Copyright infringement");
                  }}
                />
                <label className="mr-2">Copyright infringement</label>
              </div>
              <div
                className="radio"
                onClick={() => {
                  setSelectTypeofabuse("Spam, malware or phishing");
                }}
              >
                <input
                  type="radio"
                  value="Spam, malware or phishing"
                  checked={SelectTypeofabuse === "Spam, malware or phishing"}
                  onChange={() => {
                    setSelectTypeofabuse("Spam, malware or phishing");
                  }}
                />
                <label className="mr-2">Spam, malware or phishing</label>
              </div>
              <div
                className="radio"
                onClick={() => {
                  setSelectTypeofabuse("Hate, violence or illegal content");
                }}
              >
                <input
                  type="radio"
                  value="Hate, violence or illegal content"
                  checked={
                    SelectTypeofabuse === "Hate, violence or illegal content"
                  }
                  onChange={() => {
                    setSelectTypeofabuse("Hate, violence or illegal content");
                  }}
                />
                <label className="mr-2">
                  Hate, violence or illegal content
                </label>
              </div>
              <button
                type="button"
                onClick={() => {
                  SendAbusereport();
                }}
                class="btn btn-primary btn-sm shadow-add mt-3"
              >
                <p className="mb-0 subcollapse">Submit report</p>
              </button>
            </div>
            <button
              className="btn btn-link modalcolsebtn"
              onClick={toggleReportabuse}
            >
              <i className="fa-2x ion ion-md-close-circle"></i>
            </button>
            <div lassName="container-fluid ">
              <div className="flex-wrap row justify-content-center mt-3">
                <a
                  href={"https://qrcode-stt.com/"}
                  target="_blank"
                  name={"Report abuse"}
                  className={"btn btn-link"}
                >
                  Report abuse
                  {"STT"}
                </a>
                <a
                  href={"https://qrcode-stt.com/privacy-policy"}
                  target="_blank"
                  name={"Terms of Service"}
                  className={"btn btn-link"}
                >
                  {"Privacy Policy"}
                </a>
                <a
                  href={"https://qrcode-stt.com/contact-us"}
                  target="_blank"
                  name={"Help"}
                  className={"btn btn-link"}
                >
                  {"Help"}
                </a>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ModalVideo
        channel="custom"
        autoplay={true}
        isOpen={isOpen}
        url={OtherYouTubeLink}
        onClose={() => {
          setOtherYouTubeLink("");
          setTimeout(() => {
            setOpen(false);
          }, 300);
        }}
      />
      <Modal
        isOpen={ModalVideoPlayer}
        toggle={toggleVideoPlayer}
        className="modalcenter text-center YoutubeModal"
      >
        <ModalBody>
          <div>
            <YouTube videoId={VideoPlayerItem} opts={opts} />
          </div>
          <button
            className="btn btn-link modalcolsebtn"
            onClick={toggleVideoPlayer}
          >
            <i className="fa-2x ion ion-md-close-circle"></i>
          </button>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={modalemailchat}
        toggle={toggleemailChat}
        className="modal-md modalcenter text-center mx-3"
      >
        <ModalBody>
          <form
            onSubmit={(e) => {
              sendemailmessgae(e);
            }}
          >
            <div className="text-center">
              <div>
                <label
                  className="d-flex align-items-end mb-1"
                  style={{ fontWeight: 700, fontSize: 15 }}
                >
                  Contact Email
                  <p style={{ fontSize: 12, color: "red" }}>*</p>
                </label>

                <input
                  type="email"
                  className="form-control input-height"
                  style={{ fontWeight: "bold" }}
                  placeholder="Enter your email address"
                  value={userchatemail}
                  onChange={(e) => {
                    setCompanyEmailError("");
                    setuserchatemail(e.target.value);
                  }}
                  required
                />
                {CompanyEmailError.length > 0 ? (
                  <span
                    style={{
                      color: "red",
                      fontSize: "12px",
                      fontWeight: "500",
                      marginLeft: "10px",
                    }}
                  >
                    {CompanyEmailError}
                  </span>
                ) : (
                  ""
                )}
                <label
                  className="d-flex align-items-end mb-1 mt-4"
                  style={{ fontWeight: 700, fontSize: 15 }}
                >
                  Name (optional)
                </label>
                <input
                  type="text"
                  className="form-control input-height"
                  style={{ fontWeight: "bold" }}
                  placeholder="Enter your name"
                  value={userchatname}
                  onChange={(e) => {
                    setuserchatname(e.target.value);
                  }}
                />
                <textarea
                  name="postContent"
                  className="form-control input-height mt-4"
                  rows={5}
                  cols={40}
                  style={{ fontWeight: "bold" }}
                  value={userchatmessage}
                  onChange={(e) => {
                    console.log(e?.target?.value?.length);
                    if (e?.target?.value?.length <= 300) {
                      setuserchatmessage(e.target.value);
                    }
                  }}
                  placeholder="Write about the product"
                />
                <p
                  style={{
                    textAlign: "right",
                    fontSize: 12,
                    color: "red",
                    marginBottom: 0,
                  }}
                >
                  {userchatmessage.length}/300
                </p>

                <div className="d-flex align-items-center">
                  <label
                    className="d-flex align-items-center mt-2"
                    htmlFor="defaultCheckbox"
                    style={{ fontWeight: 500, fontSize: 15 }}
                  >
                    {" "}
                    <p className="text-left" style={{ fontWeight: 500, fontSize: 15, textAlign: "left" }}>  Send a message copy to me </p>
                    {/* <p className="text-left">   By sending the message, I agree   <a
                      href="https://qrcode-stt.com/privacy-policy/"
                      className=""
                      style={{ fontWeight: 500, fontSize: 15, textAlign: "left" }}
                    >
                       term and condition{" "}
                    </a></p> */}
                  </label>
                  <input
                    className="form-check-input"
                    style={{
                      position: "relative",
                      height: "17px",
                      width: "17px",
                      marginBottom: '18px',
                      marginLeft: 'auto'
                    }}
                    type="checkbox"
                    checked={ischatsendme}
                    onChange={(e) => {
                      setischatsendme(e.target.checked);
                    }}
                    id="defaultCheckbox"
                  />
                </div>
                <p style={{ fontWeight: 500, fontSize: 12 }}>   By sending the message, I agree   <a
                  href="https://qrcode-stt.com/privacy-policy/"
                  className=""
                  style={{ fontWeight: 400, fontSize: 12 }}
                >
                  term and condition{" "}
                </a></p>
              </div>

            </div>

            {/* <div style={{ textAlign: "left" }}>
              <a
                href="https://qrcode-stt.com/privacy-policy/"
                className=""
                style={{ fontWeight: 500, fontSize: 15, textAlign: "left" }}
              >
                Term and Condition{" "}
              </a>
            </div> */}
            <div className="d-flex float-end justify-content-end">
              <button type="submit" class="btn btn-success m-b-5 m-r-5">
                Send
              </button>
            </div>
          </form>
          <button
            className="btn btn-link modalcolsebtn"
            // style={{color:'red'}}
            onClick={toggleemailChat}
          >
            <i className="fa-2x ion ion-md-close-circle" style={{ color: 'red' }}></i>
          </button>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Detail;
